import React from 'react';
import { Tag } from 'antd';
import { ConfirmationStatus } from '../../../../core-module/services/absence/types';

interface Props {
  readonly confirmationStatus: ConfirmationStatus;
}

const ConfirmationStatusBadge: React.FC<Props> = ({ confirmationStatus }) => {
  switch (confirmationStatus) {
    case 'Unconfirmed':
      return (
        <Tag color='#9c9392' style={{ margin: 0 }}>
          Nog niet bevestigd
        </Tag>
      );
    case 'Rejected':
      return <Tag color='#f50' style={{ margin: 0 }}>Afgewezen</Tag>;
    case 'Confirmed':
      return <Tag color='#87d068' style={{ margin: 0 }}>Bevestigd</Tag>;
    default:
      return null;
  }
};

export { ConfirmationStatusBadge };
